export default __webpack_public_path__ + "static/media/check-danger.d56062e7.svg";